
/**
 * 상세 에러 정보 (선택적)
 * @nullable
 */
export type NotFoundResponseResponseDetails = { [key: string]: unknown } | null;
